"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var ImagePicker_1 = __importDefault(require("../../../../common/ImagePicker/ImagePicker"));
var TextInput_1 = __importDefault(require("../../../../common/TextInput/TextInput"));
var CategorySelector_1 = __importDefault(require("../Selectors/CategorySelector"));
var general_1 = require("../../../../lib/general");
var validate_1 = require("../validate");
var SortingSelector_1 = __importDefault(require("../Selectors/SortingSelector"));
function DiseaseForm(props) {
    var arr = props.languages, arr1 = props.languages, arr2 = props.languages, _a = (0, react_1.useState)({
        id: null,
        title: JSON.stringify(arr),
        category: null,
        icon: null,
        thumbnail: arr1,
        video: arr2,
        sorting: null,
    }), formData = _a[0], setFormData = _a[1], _b = (0, react_1.useState)({
        thumbnail: null,
        video: null,
    }), fileName = _b[0], setFileName = _b[1], _c = (0, react_1.useState)(null), error = _c[0], setError = _c[1], videoRef = (0, react_1.createRef)(), _d = (0, react_i18next_1.useTranslation)(), t = _d.t, i18n = _d.i18n, getCurrentLang = i18n.language;
    (0, react_1.useEffect)(function () {
        if (props.saveClickStatus) {
            props.updateSaveClickStatus();
            saveDisease();
        }
    }, [props.saveClickStatus]);
    var resetDocumentRef = function () {
        videoRef.current.value = null;
    };
    (0, react_1.useEffect)(function () {
        resetDocumentRef();
        setFileName(function (prevState) { return (__assign(__assign({}, prevState), { thumbnail: null, video: null })); });
    }, [getCurrentLang]);
    (0, react_1.useEffect)(function () {
        if (props.onEditClick) {
            resetDocumentRef();
            setFileName({
                thumbnail: null,
                video: null,
            });
            setFormData(props.onEditClick);
        }
    }, [props.onEditClick]);
    (0, react_1.useEffect)(function () {
        if (formData && formData.category !== null) {
            var check_category = typeof formData.category === "object" && formData.category !== null
                ? formData.category.value
                : formData.category;
            props.categoryId(check_category);
        }
    }, [formData]);
    var saveDisease = function () {
        var res = (0, validate_1.ValidateDiseaseForm)(formData, getCurrentLang);
        if (res.status === "error") {
            setError(res);
        }
        else {
            window.scrollTo(0, 0);
            props.saveDisease(formData);
        }
    }, onHandleChange = function (value, data_type, isJson) {
        setError(null);
        if (isJson === "json") {
            var dataObj_1 = JSON.parse(formData[data_type]);
            dataObj_1[getCurrentLang] = value;
            setFormData(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[data_type] = JSON.stringify(dataObj_1), _a)));
            });
        }
        else if (isJson === "obj") {
            var currentInput_1 = data_type;
            var video_file_1 = value.video_file, thumbnail_file_1 = value.thumbnail_file;
            if (video_file_1) {
                setFileName(function (prevState) {
                    var _a;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[currentInput_1] = video_file_1.name, _a)));
                });
                setFormData(function (prevState) {
                    var _a, _b;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[currentInput_1] = __assign(__assign({}, prevState[currentInput_1]), (_b = {}, _b[getCurrentLang] = video_file_1, _b)), _a)));
                });
            }
            if (thumbnail_file_1) {
                setFormData(function (prevState) {
                    var _a, _b;
                    return (__assign(__assign({}, prevState), (_a = {}, _a["thumbnail"] = __assign(__assign({}, prevState["thumbnail"]), (_b = {}, _b[getCurrentLang] = thumbnail_file_1, _b)), _a)));
                });
            }
        }
        else {
            if (data_type === "icon") {
                setFileName(function (prevState) {
                    var _a;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[data_type] = value.name, _a)));
                });
            }
            setFormData(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[data_type] = value, _a)));
            });
        }
    };
    return (react_1.default.createElement("div", { className: "form-container" },
        react_1.default.createElement(CategorySelector_1.default, { error: error && error.field === "category" && error.message, label: t("category"), list: props.list, updateCategory: function (val) { return onHandleChange(val, "category", ""); }, value: formData.category }),
        react_1.default.createElement(TextInput_1.default, { error: error && error.field === "title" && error.message, label: t("title"), onChange: function (e) { return onHandleChange(e.target.value, "title", "json"); }, value: (0, general_1.isJsonWithAvailableLang)(formData.title, getCurrentLang.toLowerCase(), t) }),
        react_1.default.createElement(SortingSelector_1.default, { list: props.diseaseInfoDetailList, label: "sorting_order", onChange: function (e) {
                onHandleChange(e.sorting_id, "sorting_order", "");
            }, value: formData.sorting_order }),
        react_1.default.createElement(ImagePicker_1.default, { fileName: fileName, id: "video", imagechange: function (video_file, thumbnail_file) {
                var file = { video_file: video_file, thumbnail_file: thumbnail_file };
                onHandleChange(file, "video", "obj");
            }, imgref: videoRef, label: t("video"), mediatype: "video" })));
}
exports.default = DiseaseForm;
